import React, { useState } from "react";
import {
  Nav,
  NavbarBrand,
  NavItem,
  NavLink,
  Dropdown,
  DropdownItem,
  DropdownToggle,
  DropdownMenu,
  Navbar,
} from "reactstrap";
import { Link, useNavigate } from "react-router-dom";
import { FormattedMessage, useIntl } from "react-intl";

function CourseAdminNav({ location, table }) {
  const navigate = useNavigate();
  const intl = useIntl();
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const headingTitle = () => {
    switch (location) {
      case "courses":
        return <FormattedMessage id="Courses" />;
      case "modules":
        return <FormattedMessage id="Modules" />;
      case "licenses":
        return <FormattedMessage id="Licenses" />;
      case undefined:
        if (table === "studGrade") {
          return (
            <>
              <FormattedMessage id="CourseGrades" /> - <FormattedMessage id="StudentComments" />
            </>
          );
        } else if (table === "moduleGrade") {
          return (
            <>
              <FormattedMessage id="CourseGrades" /> - <FormattedMessage id="ModuleGrades" />
            </>
          );
        }
        break;
      default:
        return "";
    }
  };

  return (
    <Navbar
      container={false}
      color="primary"
      dark
      expand="md"
      className="px-3"
    >
      <NavbarBrand>{headingTitle()}</NavbarBrand>
      <Nav className="ms-auto" navbar>
        <NavItem>
          <NavLink
            href="#"
            onClick={() => navigate("/superuser/courses")}
            title={intl.formatMessage({ id: "AllCourses" })}
            disabled={location === "courses"}
            active={location === "courses"}
          >
            <FormattedMessage id="Courses" />
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            href="#"
            onClick={() =>
              navigate("/superuser/courses/modules")
            }
            disabled={location === "modules"}
            active={location === "modules"}
            title={intl.formatMessage({ id: "AllModules" })}
          >
            <FormattedMessage id="Modules" />
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            href="#"
            onClick={() =>
              navigate("/superuser/courses/licenses")
            }
            disabled={location === "licenses"}
            active={location === "licenses"}
            title={intl.formatMessage({ id: "Licenses" })}
          >
            <FormattedMessage id="Licenses" />
          </NavLink>
        </NavItem>
        <Dropdown isOpen={dropdownOpen} toggle={() => setDropdownOpen(!dropdownOpen)}>
          <DropdownToggle nav caret id="courseAdmin--Dropdown-toggler">
            <FormattedMessage id="CourseGrades" />
          </DropdownToggle>
          <DropdownMenu className="mt-2" id="courseAdmin--Dropdown-menu">
            <DropdownItem
              tag="span"
              disabled={table === "studGrade"}
              active={table === "studGrade"}
              className="courseAdmin--Dropdown-item"
            >
              <Link
                to="/superuser/courses/ratings"
                state={{ table: "studGrade" }}
                replace
                className="courseAdminNav--Dropdown-link"
              >
                <FormattedMessage id="StudentComments" />
              </Link>
            </DropdownItem>
            <DropdownItem
              tag="span"
              disabled={table === "moduleGrade"}
              active={table === "moduleGrade"}
              className="courseAdmin--Dropdown-item"
            >
              <Link
                to="/superuser/courses/ratings"
                state={{ table: "moduleGrade" }}
                replace
                className="courseAdminNav--Dropdown-link"
              >
                <FormattedMessage id="ModuleGrades" />
              </Link>
            </DropdownItem>
          </DropdownMenu>
        </Dropdown>
      </Nav>
    </Navbar>
  );
}

export default CourseAdminNav;
